import * as Sentry from '@sentry/react';

class ErrorLoggingServerService {
  logMessageToServer = (message, level = 'log') => {
    Sentry.captureMessage(message, level);
  };

  logExceptionToServer = (error) => {
    Sentry.captureException(error);
  };

  logBreadCrumbToServer = (breadcrumb) => {
    Sentry.addBreadcrumb(breadcrumb);
  };

  configureUserScope = (user) => {
    Sentry.setUser(user);
  };
}

const errorLoggingServerService = new ErrorLoggingServerService();

export default errorLoggingServerService;
